import React, { useEffect, useState } from 'react';
import { Grid, TextField, Box, Paper, Typography } from '@mui/material';

const QuestionReviewTools = ({ logger, anonGroup, setReviewQuestionsData, location }) => {
  const [surveyContext, setSurveyContext] = useState('');
  const [surveyLocations, setSurveyLocations] = useState('');

  useEffect(() => {
    setReviewQuestionsData({ surveyContext, surveyLocations });
  }, [surveyContext, surveyLocations]);

  return (
    <Grid item xs={12}>
      <Box m={1}>
        <Paper elevation={3} style={{ padding: '1em' }}>
          <Typography variant="h6" gutterBottom>
            AI question review
          </Typography>
          <Box mb={2}>
            <Typography variant="body1" gutterBottom>
              Once you&apos;ve loaded your Excel form definition, click any <i>AI review</i> button below to review a question or group of questions. Optionally, add some details about your survey in the fields below, to help the AI conduct a more well-informed review.
            </Typography>
          </Box>
          <Box mb={2}>
            <TextField
              name="surveyContext"
              multiline
              rows={2}
              variant="outlined"
              fullWidth
              label="Survey context (optional)"
              placeholder="Enter a brief description of the survey context..."
              InputLabelProps={{ shrink: true }}
              value={surveyContext}
              onChange={e => setSurveyContext(e.target.value)}
            />
          </Box>
          <Box mb={2}>
            <TextField
              name="surveyLocations"
              multiline
              rows={2}
              variant="outlined"
              fullWidth
              label="Survey locations and languages (optional)"
              placeholder="List the locations where the survey will be conducted, and in which languages (e.g., 'Kenya (Swahili, English), South Africa (Afrikaans, English)')..."
              InputLabelProps={{ shrink: true }}
              value={surveyLocations}
              onChange={e => setSurveyLocations(e.target.value)}
            />
          </Box>
        </Paper>
      </Box>
    </Grid>
  );
};

export default QuestionReviewTools;
